import {
  ContactResultSkeleton,
  SerializedContactTeaserData,
} from '@ltvco/refresh-lib/v1';
import { NoResultsFound } from '@ltvco/refresh-lib/v2';

import { ContactCards } from '../Cards/ContactCards';

interface ContactResultsContainerProps {
  results: SerializedContactTeaserData | undefined;
}

export function ContactResultsContainer({
  results,
}: ContactResultsContainerProps) {
  return !results ? (
    <ContactResultSkeleton />
  ) : results.total <= 0 ? (
    <NoResultsFound />
  ) : (
    <ContactCards searchContactResult={results} />
  );
}
